import { Field, FieldGroup, FieldLabel } from '@/components/ui/field'
import { Input } from '@/components/ui/input'
import type { NewTeammate } from '@/models/confirmInfo'

export const NO_PERSON: NewTeammate = { firstName: '', lastName: '', email: '' }

export function isPersonFilled(person: NewTeammate): boolean {
  return !!(person.firstName.trim() && person.lastName.trim() && person.email.trim())
}

interface NewPersonFieldsProps {
  idPrefix: string
  person: NewTeammate
  onChange: (person: NewTeammate) => void
}

/** The name and email someone is added by before their link goes out. */
export function NewPersonFields({ idPrefix, person, onChange }: NewPersonFieldsProps) {
  const update = (patch: Partial<NewTeammate>) => onChange({ ...person, ...patch })

  return (
    <FieldGroup>
      <div className="grid gap-4 sm:grid-cols-2">
        <Field>
          <FieldLabel htmlFor={`${idPrefix}-first-name`}>First name</FieldLabel>
          <Input
            id={`${idPrefix}-first-name`}
            autoComplete="off"
            value={person.firstName}
            onChange={(event) => update({ firstName: event.target.value })}
          />
        </Field>
        <Field>
          <FieldLabel htmlFor={`${idPrefix}-last-name`}>Last name</FieldLabel>
          <Input
            id={`${idPrefix}-last-name`}
            autoComplete="off"
            value={person.lastName}
            onChange={(event) => update({ lastName: event.target.value })}
          />
        </Field>
      </div>
      <Field>
        <FieldLabel htmlFor={`${idPrefix}-email`}>Email</FieldLabel>
        <Input
          id={`${idPrefix}-email`}
          type="email"
          inputMode="email"
          autoComplete="off"
          value={person.email}
          onChange={(event) => update({ email: event.target.value })}
        />
      </Field>
    </FieldGroup>
  )
}
